export class Country {
	constructor(public key: string, public name: string) {}
}
